console.log("worker running...");


import * as fs	from "fs";
import sleep	from "sleep";

const PATH = "/var/lib/biocore/server/fermentations";

// an async generator that reads the input file chunk by chunk and yields each line
async function *readline(path) {
  const MAXCHUNKSIZE = 5000;
  var lines = [""];

  var size = fs.statSync(path).size-1;
  var position = 0;
  var chunk;
  
  do {
    chunk = String.fromCharCode.apply(null, new Uint8Array(fs.readFileSync(path, {
      offset: position,
      count: MAXCHUNKSIZE
    })) );

    position += MAXCHUNKSIZE;

    chunk = chunk.split("\n");
    lines[0] += chunk.shift();
    lines = lines.concat(chunk);

    while(lines.length-1) {
      await sleep(0);
      yield lines.shift();
    }

  } while(position<size);

  return lines.shift();
}

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

const POINTS = 640;

// an async generator that reads the input file chunk by chunk and yields each line
async function *readline640(path) {
  const MAXCHUNKSIZE = 2500;

  var size = fs.statSync(path).size-1;
  var skip = Math.round(size/POINTS);
  
  for (var position=0;position<size;position+=skip) {
    let chunk = String.fromCharCode.apply(null, new Uint8Array(fs.readFileSync(path, {
      offset: position,
      count: MAXCHUNKSIZE
    })) );
    
    chunk = chunk.split("\n");
    
    if (isJsonString(chunk[0])) yield chunk[0];
    else if (isJsonString(chunk[1])) yield chunk[1];
    else if (isJsonString(chunk[2])) yield chunk[2];       
  }
   
  //return lines.shift();
}

globalThis.onmessage = async function(event) {
  try {    
    console.log("worker got task");
    var from = new Date(event.data.from);
    var to = new Date(event.data.to);

    var values = [];

    var path = `${PATH}/${event.data.id}/values.json`;
    for await (const line of readline640(path)) {     
      try {
        var record = JSON.parse(line);
        values.push(record);
      } catch(e) {
        console.warn(`Invalid entry in datafile ${path} at line ?. Skipped.`);
      }
    }

    globalThis.postMessage(values);
    console.log("done");

    //globalThis.close();
  } catch(e) {
    console.error(e);
    globalThis.postMessage([]);
    //globalThis.close();
  }
};